import Tooltip from 'react-bootstrap/Tooltip'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import React, {useEffect, useState} from 'react'
import {
    EXTRANET_STATE_DELIVERED,
    EXTRANET_STATE_DELIVERED_AFTER_DELIVERY_NOTIFICATION,
    EXTRANET_STATE_DELIVERING,
    EXTRANET_STATE_EXEC_ACCEPTED,
    EXTRANET_STATE_EXEC_AUTO_ACCEPTED,
    EXTRANET_STATE_EXEC_REFUSED,
    EXTRANET_STATE_NOTICE_OF_PASSAGE,
    EXTRANET_STATE_PREPARED_BOUQUET,
    EXTRANET_STATE_RECIPIENT_CALLED,
    EXTRANET_STATE_RECIPIENT_NOT_REPLY,
    EXTRANET_STATE_REFUSED_BY_CUSTOMER, EXTRANET_STATE_REFUSED_BY_CUSTOMER_AFTER_DELIVERY_NOTIFICATION,
    EXTRANET_STATE_SHOPPER_ADDED,
    EXTRANET_STATE_SHOPPER_BOOKED,
    EXTRANET_STATE_STOP_RING,
    EXTRANET_STATE_WAITING_RESPONSE,
} from '../../../hooks/useExtranetState'

interface PictoPropsInterface {
  appendTitle?: string;
  classNames?: string;
  color?: string;
  desc?: boolean;
  icon?: string;
  iconSize?: string;
  iconClassNames?: string;
  iconColor?: string;
  id?: string | number;
  pictoClassNames?: string;
  pictoSize?: string;
  sorting?: string;
  title?: string;
}
const Picto = ({
  id,
  sorting,
  desc,
  title,
  appendTitle,
  classNames,
  color,
  icon,
  iconSize,
  iconClassNames,
  iconColor,
  pictoClassNames,
  pictoSize,
}: PictoPropsInterface) => {
  const [newIcon, setNewIcon] = useState()
  const [newTitle, setNewTitle] = useState()
  const [newColor, setNewColor] = useState()
  const [newPictoClassNames, setNewPictoClassNames] = useState()
  const [newIconSize, setNewIconSize] = useState()
  const [newPictoSize, setNewPictoSize] = useState()

  // Gestion du choix du picto
  const handlePicto = () => {
    if (sorting === 'statut') {
      if (Number(id) === 0) {
        setNewIcon('times')
        setNewTitle('Non fondé')
        setNewColor('red')
        setNewPictoClassNames('circle')
        setNewIconSize('sm')
        setNewPictoSize('sm')
      } else {
        setNewIcon('check')
        setNewTitle('Fondé')
        setNewColor('green')
        setNewPictoClassNames('circle')
        setNewIconSize('sm')
        setNewPictoSize('sm')
      }
    } else if (sorting === 'etat') {
      if (Number(id) === 0) {
        setNewIcon('check')
        setNewTitle('En cours')
        setNewColor('green')
        setNewPictoClassNames('circle')
        setNewIconSize('sm')
        setNewPictoSize('sm')
      } else {
        setNewIcon('times')
        setNewTitle('Clôturé')
        setNewColor('red')
        setNewPictoClassNames('circle')
        setNewIconSize('sm')
        setNewPictoSize('sm')
      }
    } else if (Number(id) === 0) {
      setNewIcon('file-alt')
      setNewTitle('Etat initial')
      setNewColor('primary')
    } else if (Number(id) === 1) {
      setNewIcon('hourglass-half')
      setNewTitle('Etat en traitement')
      setNewColor('yellow-base')
    } else if (Number(id) === EXTRANET_STATE_WAITING_RESPONSE) {
      setNewIcon('pause')
      setNewTitle('Commande transmise')
      setNewColor('yellow-base')
    } else if (Number(id) === EXTRANET_STATE_EXEC_REFUSED) {
      setNewIcon('times')
      setNewTitle('Exécutant refuse la commande')
      setNewColor('red')
    } else if (Number(id) === EXTRANET_STATE_EXEC_ACCEPTED) {
      setNewIcon('check')
      setNewTitle('Exécutant accepte la commande')
      setNewColor('green-darkest')
    } else if (Number(id) === EXTRANET_STATE_DELIVERING) {
        setNewIcon('clover')
        setNewTitle('Commande en cours')
        setNewColor('primary-dark')
    } else if (Number(id) === EXTRANET_STATE_DELIVERED) {
        setNewIcon('smile')
        setNewTitle('Commande livrée')
        setNewColor('primary-dark')
    } else if (Number(id) === EXTRANET_STATE_NOTICE_OF_PASSAGE) {
        setNewIcon('map-marker-alt')
        setNewTitle('Avis de passage déposé ou destinataire appelé')
        setNewColor('orange')
    } else if (Number(id) === EXTRANET_STATE_REFUSED_BY_CUSTOMER) {
        setNewIcon('exclamation-triangle')
        setNewTitle('Refus par le client final')
        setNewColor('red')
    } else if (Number(id) === EXTRANET_STATE_STOP_RING) {
        setNewIcon('bell-slash')
        setNewTitle('Arrêt sonnerie')
        setNewColor('primary')
    } else if (Number(id) === 30) {
        setNewIcon('exclamation-triangle')
        setNewTitle('Refus après TO')
        setNewColor('red-darkest')
    } else if (Number(id) === EXTRANET_STATE_EXEC_AUTO_ACCEPTED) {
        setNewIcon('check-double')
        setNewTitle('Commande auto-acceptée')
        setNewColor('green-darkest')
    } else if (Number(id) === EXTRANET_STATE_RECIPIENT_CALLED) {
        setNewIcon('phone')
        setNewTitle('Destinataire appelé')
        setNewColor('green-darkest')
    } else if (Number(id) === EXTRANET_STATE_RECIPIENT_NOT_REPLY) {
        setNewIcon('phone-slash')
        setNewTitle('Destinataire ne répond pas')
        setNewColor('red-darkest')
    } else if (Number(id) === EXTRANET_STATE_PREPARED_BOUQUET) {
        setNewIcon('gift')
        setNewTitle('Bouquet préparé')
        setNewColor('blue')
    } else if (Number(id) === EXTRANET_STATE_SHOPPER_ADDED) {
        setNewIcon('calendar')
        setNewTitle('Demande de livraison par un livreur envoyée.')
        setNewColor('yellow-base')
    } else if (Number(id) === EXTRANET_STATE_SHOPPER_BOOKED) {
        setNewIcon('handshake')
        setNewTitle('La livraison a été acceptée par un livreur.')
        setNewColor('primary-dark')
    } else if (Number(id) === EXTRANET_STATE_DELIVERED_AFTER_DELIVERY_NOTIFICATION) {
        setNewIcon('smile-wink')
        setNewTitle('Commande livrée après avis de passage')
        setNewColor('primary-dark')
    } else if (
        Number(id) ===
        EXTRANET_STATE_REFUSED_BY_CUSTOMER_AFTER_DELIVERY_NOTIFICATION
    ) {
        setNewIcon('exclamation-triangle')
        setNewTitle('Refus par le client final après avis de passage')
        setNewColor('red-darkest')
    } else {
        return false
    }
    return true
  }

  useEffect(() => {
    handlePicto()
  }, [])

  return (
    <>
      {(newIcon || icon) && (
        <>
          <div
            className={`d-flex flex-row align-items-center ${
              !desc ? 'justify-content-center' : ''
            }${classNames ? ` ${classNames}` : ''}`}>
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id={`tooltip-${id}`}>
                    {newTitle ? <>{newTitle} {appendTitle}</> : title }
                </Tooltip>
              }>
              <div
                className={`picto${
                  pictoSize
                    ? `-${pictoSize}`
                    : newPictoSize
                    ? `-${newPictoSize}`
                    : ''
                } text-${newColor || color}${
                  pictoClassNames
                    ? ` ${pictoClassNames}`
                    : newPictoClassNames
                    ? ` ${newPictoClassNames}`
                    : ''
                }`}>
                <FontAwesomeIcon
                  icon={newIcon || icon || 'home'}
                  size={iconSize || newIconSize || 'lg'}
                  className={iconClassNames}
                  // color={iconColor || 'white'}
                />
              </div>
            </OverlayTrigger>
            {desc && <div className="text-left">{newTitle || title}</div>}
          </div>
        </>
      )}
    </>
  )
}

export default Picto
